<template>
    <div><!-- This div is the router-view -->
        <div class="row justify-content-center" v-if="loaded.contracts.length < requiredContracts.length">
            <div class="col-12 col-xl-9 col-xxl-7">
                <div class="panel bg-dark text-white">
                    <div class="panel-body">
                        <div class="row justify-content-center mb-3">
                            <div class="col-12 text-center">
                                <span class="text-blue fs-1 fw-bold pt-3">Dashboard</span>
                            </div>
                        </div>
                        <div class="row justify-content-center mb-3">
                            <div class="col-12 col-lg-6 text-start">
                                <div class="progress">
                                    <div class="progress-bar bg-blue text-dark" v-bind:style="'width: ' + (loaded.contracts.length * 100 / requiredContracts.length).toFixed(0) + '%;'">
                                        {{(loaded.contracts.length * 100 / requiredContracts.length).toFixed(0)}} %
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center mb-3">
                            <div class="col-12 col-lg-6 text-start">
                                Currently loading all contracts: {{loaded.contracts.length}} / {{requiredContracts.length}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="loaded.contracts.length >= requiredContracts.length" style="display:fixed !important;">
            <div class="col-12">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-4">
                        <div class="panel bg-dark text-white">
                            <div class="panel-body">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h1 class="text-center">{{wallet.balances.PEARLZ.toFixed($root.$children[0].displayDecimals)}}</h1>
                                        <h4 class="text-center text-blue">Your $PRLZ</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="panel bg-dark text-white">
                            <div class="panel-body">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h1 class="text-center">{{claimable.toFixed($root.$children[0].displayDecimals)}}</h1>
                                        <h4 class="text-center text-blue">Claimable $PRLZ</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-4">
                        <button type="button" class="btn btn-grad btn-lg text-dark w-100" v-on:click="claimPayout">{{processing.claimPayout ? 'PROCESSING...' : 'CLAIM PAYOUT'}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {

        data() {
            return {
                requiredContracts: ["BUSD", "PEARLZ", "PearlzCreditSystem"],
                loaded: {
                    contracts: []
                },
                claimable: 0,
                processing: {
                    claimPayout: false,
                },
            }
        },

        created() {
            this.$eventBus.$on("contracts/instantiateContract", (event) => {
                if (!this.requiredContracts.includes(event.payload)) {return;}
                if (event.payload === "PearlzCreditSystem") {
                    this.loaded.contracts.push(event.payload);
                    this.autoRefresh();
                    return;
                }
                this.$root.$children[0].verifyRequestConditionsAndContinueOrDelay('getWalletBalance', event.payload);
            });

            this.$eventBus.$on("wallet/getWalletBalance", (event) => {
                if (!this.requiredContracts.includes(event.payload)) {return;}
                this.$root.$children[0].verifyRequestConditionsAndContinueOrDelay('callAllowanceAmount', event.payload);
            });

            this.$eventBus.$on("updateAllowanceAmount", (event) => {
                if (!this.requiredContracts.includes(event.payload)) {return;}
                if (this.loaded.contracts.includes(event.payload)) {return;}
                this.loaded.contracts.push(event.payload);
            });
        },

        updated () {
        },

        computed: {
            ...mapState(['contracts', 'pairs', 'session', 'wallet', 'web3'])
        },

        watch: {
            "session.isConnected": function(newVal, oldVal) {
                if (newVal === true && oldVal === false) {this.initiate();}
            }
        },

        methods: {
            initiate: function() {
                this.$root.$children[0].verifyRequestConditionsAndContinueOrDelay('getRequiredContracts', this.requiredContracts);
                this.$root.$children[0].verifyRequestConditionsAndContinueOrDelay('getRequiredPairs', this.requiredPairs);
            },

            autoRefresh: function() {
                this.updateDatas();
                let self = this;
                setTimeout(function() {
                    if (['/dashboard', '/dashboard/'].includes(self.$route.path)) {self.updateDatas();}
                }, 5000);
            },

            updateDatas: async function() {
                this.claimable = Number(this.web3.instance.utils.fromWei(await this.contracts.PearlzCreditSystem.instance.methods.availableClaim(this.wallet.account).call()));
            },

            claimPayout: async function() {
                if (this.processing.claimPayout) {return;}
                this.processing.claimPayout = true;
                try {
                    await this.contracts.PearlzCreditSystem.instance.methods.claimPayout().send({from: this.wallet.account});
                } catch (e) {
                    // console.log(e);
                    this.processing.claimPayout = false;
                    return;
                }
                this.processing.claimPayout = false;
                this.updateDatas();
            },
        },

        mounted() {
            this.initiate();
        }
    }
</script>